<script setup>
import Modal from "@/components/modal/Modal";

const props = defineProps({
    patientCounts: {
        type: Object,
        required: false,
        default: {}
    },
    hideBlackAndWhite: {
        type: Boolean,
        required: false,
        default: false
    }
})

const emit = defineEmits(['close'])

function close() {
    emit('close')
}

function displayValue(value) {
    return value === null ? '?' : value
}
</script>

<template>
    <Modal :title="pgettext('label', 'Legend')"
           @close="close"
           :closeOnClickOutside="true"
           class="w-lg-25 w-md-50">
        <v-table>
            <tbody>
            <tr>
                <td>{{ pgettext('label_for_group_of_people', 'Seriously injured') }}</td>
                <td>
                    <v-chip color="red" density="compact" variant="flat" :ripple="false" rounded
                            class="hpo-counts-block__value px-2">
                        <strong>
                            {{ displayValue(patientCounts.red) }}
                        </strong>
                    </v-chip>
                </td>
            </tr>
            <tr>
                <td>{{ pgettext('label_for_group_of_people', 'Moderately injured') }}</td>
                <td>
                    <v-chip color="yellow" density="compact" variant="flat" :ripple="false" rounded
                            class="hpo-counts-block__value px-2">
                        <strong>
                            {{ displayValue(patientCounts.yellow) }}
                        </strong>
                    </v-chip>
                </td>
            </tr>
            <tr>
                <td>{{ pgettext('label_for_group_of_people', 'Slightly injured') }}</td>
                <td>
                    <v-chip color="green" density="compact" variant="flat" :ripple="false" rounded
                            class="hpo-counts-block__value px-2">
                        <strong>
                            {{ displayValue(patientCounts.green) }}
                        </strong>
                    </v-chip>
                </td>
            </tr>
            <template v-if="!hideBlackAndWhite">
                <tr>
                    <td>{{ pgettext('label_for_group_of_people', 'Deceased') }}</td>
                    <td>
                        <v-chip v-if="patientCounts.hasOwnProperty('black')"
                                color="black" density="compact" variant="flat" :ripple="false" rounded
                                class="hpo-counts-block__value px-2">
                            <strong>
                                {{ displayValue(patientCounts.black) }}
                            </strong>
                        </v-chip>
                    </td>
                </tr>
                <tr>
                    <td>{{ pgettext('label_for_group_of_people', 'Uninjured') }}</td>
                    <td>
                        <v-chip v-if="patientCounts.hasOwnProperty('uninjured')"
                                density="compact" variant="outlined" :ripple="false" rounded
                                class="hpo-counts-block__value px-2">
                            <strong>
                                {{ displayValue(patientCounts.uninjured) }}
                            </strong>
                        </v-chip>
                    </td>
                </tr>
            </template>
            </tbody>
        </v-table>
    </Modal>
</template>

